import { render, staticRenderFns } from "./SeatSelection.vue?vue&type=template&id=281af19e&scoped=true&v-if=tribuneSeats&"
import script from "./SeatSelection.vue?vue&type=script&lang=js&"
export * from "./SeatSelection.vue?vue&type=script&lang=js&"
import style0 from "./SeatSelection.vue?vue&type=style&index=0&id=281af19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281af19e",
  null
  
)

export default component.exports